'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const utils_debounce = require('../../../utils/debounce.cjs.js');
const components_display_Avatar_Avatar = require('../../display/Avatar/Avatar.cjs.js');
require('clsx');
require('../../display/Carousel/Carousel.cjs.js');
const components_display_Carousel_ScrollSnap_ScrollSnap = require('../../display/Carousel/ScrollSnap/ScrollSnap.cjs.js');
const components_navigation_Paginator_Paginator = require('../../navigation/Paginator/Paginator.cjs.js');
const components_marketing_TestimonialSolo_TestimonialMapping = require('../TestimonialSolo/TestimonialMapping.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("testimonialCarousel", {
  testimonialCarouselContainer: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[components_marketing_TestimonialSolo_TestimonialMapping.remapDeprecatedColors(backgroundColor)]]};
    padding: 20px;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      padding: 40px 30px;
    }
  `,
  testimonialContainerWrapper: react.css`
    ${styleMixins_reset.boxSizing};
    width: 100%;
    display: flex;
    overflow-x: auto;
    gap: 40px;
    // Fits inside our 1230px max grid, plus about 100px of padding on each side of the carousel
    // so that it is centered and not quite as wide as a Hero, for example
    max-width: 1030px;
    &::-webkit-scrollbar {
      /* Hide scrollbar for Chrome, Safari and Opera */
      display: none;
    }
    -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      gap: 60px;
    }
  `,
  testimonialContainer: react.css`
    ${styleMixins_reset.boxSizing};
    min-width: 100%;
    display: grid;
    align-items: flex-start;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px 0;
    margin-bottom: 30px;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 0 30px;
    }
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      margin-bottom: 40px;
      gap: 0 100px;
    }
  `,
  testimonial: react.css`
    ${styleMixins_reset.boxSizing};
    text-align: left;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      max-width: 339px;
    }
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      max-width: 400px;
    }
  `,
  avatarContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 20px;
  `,
  quote: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph3}
    color: ${theme_Colors.Colors.GrayWarm10};
    margin-bottom: 20px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.subHeader1}
    }
  `,
  author: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph3};
    margin: 0;
    color: ${theme_Colors.Colors.GrayWarm9};
  `
});
const TestimonialCarousel = (props) => {
  const [activeTestimonialIndex, setActiveTestimonialIndex] = React.useState(0);
  const testimonialContainerRef = React.useRef(null);
  const [testimonialContainerWidth, setTestimonialContainerWidth] = React.useState(0);
  React.useEffect(() => {
    var _a;
    setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
  }, []);
  React.useLayoutEffect(() => {
    const onResize = utils_debounce.debounce(() => {
      var _a;
      setTestimonialContainerWidth(((_a = testimonialContainerRef === null || testimonialContainerRef === void 0 ? void 0 : testimonialContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0);
    }, 100);
    window.addEventListener("resize", onResize, { capture: true });
    return () => {
      window.removeEventListener("resize", onResize, { capture: true });
    };
  });
  const paginator = react.jsx(components_navigation_Paginator_Paginator.Paginator, { currentPageIndex: activeTestimonialIndex, onPaginate: ({ pageIndex: index }) => setActiveTestimonialIndex(index), pageUrls: Array.from({ length: props.testimonials.length }) });
  return react.jsx(
    "div",
    { css: Styles.testimonialCarouselContainer(props.backgroundColor), "data-zds": true },
    react.jsx("div", { css: Styles.testimonialContainerWrapper, ref: testimonialContainerRef, "data-zds": true }, testimonialContainerWidth && react.jsx(components_display_Carousel_ScrollSnap_ScrollSnap.ScrollSnap, { gap: 60, itemWidth: testimonialContainerWidth, onScroll: (index) => {
      setActiveTestimonialIndex(index);
    }, pageIndex: activeTestimonialIndex, scrollSnapAlign: "center" }, props.testimonials.map((testimonial, i) => react.jsx(
      "div",
      { key: i, css: Styles.testimonialContainer, "data-zds": true },
      react.jsx("div", { "data-zds": true }, testimonial.mediaElement),
      react.jsx(
        "div",
        { css: Styles.testimonial, "data-zds": true },
        testimonial.hasAuthorAvatar && react.jsx(
          "div",
          { css: Styles.avatarContainer, "data-zds": true },
          react.jsx(components_display_Avatar_Avatar.Avatar, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: "medium" })
        ),
        react.jsx("div", { css: Styles.quote, "data-zds": true }, testimonial.quote),
        react.jsx(
          "p",
          { css: Styles.author, "data-zds": true },
          testimonial.author,
          ", ",
          testimonial.company
        )
      )
    )))),
    paginator
  );
};

exports.TestimonialCarousel = TestimonialCarousel;
//# sourceMappingURL=TestimonialCarousel.cjs.js.map
